import { FC } from 'react';
import ConfirmationDialog from 'components/ConfirmationDialog/ConfirmationDialog';
import styles from './removeCustomPageModal.module.less';

interface Props {
  visible: boolean;
  pageTitle: string;
  onClose: () => void;
  onRemove: () => void;
}

const RemoveCustomPageModal: FC<Props> = (props: Props) => {
  const { visible, pageTitle, onClose, onRemove } = props;

  return (
    <ConfirmationDialog
      title="Delete Page"
      visible={visible}
      onCancel={onClose}
      onOk={onRemove}
      okText="Delete Page"
      cancelText="Cancel"
      isCancelLink={true}
      flipFooterOrder={true}
      width="465px"
    >
      <>
        <div className={styles.title}>{pageTitle}</div>
        <p className={styles.description}>
          Are you sure you want to delete this page? It will be immediately
          removed from the Microsite.
        </p>
      </>
    </ConfirmationDialog>
  );
};

export default RemoveCustomPageModal;
